/******************************************************************************************
 *	Auth service for storing data about the currently logged in user.
 ******************************************************************************************/
(function() {
  

  angular
    .module('rcServices.auth', [])
    .constant('AUTH_EVENTS', {
      DONE: 'Auth:Done',
      LOGOUT: 'Auth:LoggedOut'
    })
    .service(
      'Auth',
      /* @ngInject */
      function(
        $log,
        $rootScope,
        $q,
        $http,
        AUTH_EVENTS,
        authentication,
        BlackoutError,
        CurtainNotifications,
        jilUserAuthorization,
        RC_USER_ROLES,
        Redirector,
        User
      ) {
        //Authorization object
        var auth = {
          isLoggedIn: false,
          accessToken: null
        };

        //Getters for `auth` properties
        this.isLoggedIn = function() {
          return auth.isLoggedIn === true;
        };

        //Auth is considered in progress anytime it's validating or invalidating a session
        var authInProgress = false;
        var setInProgressState = function() {
          authInProgress = true;
        };
        var unsetInProgressState = function() {
          authInProgress = false;
        };
        this.inProgress = function() {
          return authInProgress;
        };

        //JIL Authorization call
        var jilAuthorize = function() {
          $log.info('%cWaiting for JIL authorization...', 'color:#CCCCCC;');

          jilUserAuthorization.userAuthorization
            .get()
            .$promise.then(function(response) {
              //User is logged in
              auth.isLoggedIn = true;

              //Set user roles
              User.setRoles(response.roles);

              $log.info('%cLogged :: IN', 'color:#009966;font-weight:bold;');
            })
            .catch(function(response) {
              $log.info(
                '%cJIL authorization failed.',
                'color:#009966;font-weight:bold;',
                response.data,
                response.status
              );

              if (response.status === 403) {
                //Forbidden
                //Valid AdobeID, but JIL said no.
                BlackoutError.showUnauthorizedUserError();
              } else {
                //If HTTP status is not set, either the call was aborted or connectivity lost or JIL is down
                BlackoutError.showAuthorizationFailError();
              }
            })
            .finally(function() {
              //Auth DONE event
              $rootScope.$emit(AUTH_EVENTS.DONE);

              //Auth no longer in progress
              unsetInProgressState();
            });
        };

        //Authorization header
        var setHttpAuthorizationHeader = function() {
          //FR: TODO ~ Only implement this logic for calls made to JIL or Apache Proxy
          //Beyond this point all XHR calls will contain the Authorization header
          //Token type `Bearer` is hardcoded, there's no other token type.
          $http.defaults.headers.common['Authorization'] = 'Bearer ' + auth.accessToken;
        };
        var unsetHttpAuthorizationHeader = function() {
          delete $http.defaults.headers.common['Authorization'];
        };

        //Login
        this.loginDemoUser = function(accessToken) {
          if (accessToken) {
            wipeAuthData();
            auth.accessToken = accessToken;
            auth.isLoggedIn = true;
            unsetInProgressState();
          }
        };

        this.login = function(accessToken) {
          if (accessToken) {
            //Auth is in progress
            setInProgressState();

            //IMS Login done.
            $log.info('%cAccess Token ::', 'font-weight:bold;color:#009966;', accessToken);
            auth.accessToken = accessToken;

            //Set the Authorization header for all HTTP calls
            setHttpAuthorizationHeader();

            //JIL authorization
            jilAuthorize();
          }
        };

        //Logout
        //Wipe auth info from memory
        var wipeAuthData = function() {
          unsetHttpAuthorizationHeader();

          for (var prop in auth) {
            auth[prop] = null;
          }
          auth.isLoggedIn = false;
        };

        //`localLogout` only logs out user from memory, without AJAXing IMS.
        //If `silent` is passed as true, no event is fired
        this.logout = function(localLogout, silent) {
          //Auth is in progress
          setInProgressState();

          if (!localLogout) {
            $log.info('%cLogging :: OUT', 'color:#009966;font-weight:bold;');

            wipeAuthData();

            if (authentication.isUserSignedIn()) {
              authentication.signOut();
            } else {
              unsetInProgressState();
              $rootScope.$emit(AUTH_EVENTS.LOGOUT);
            }
          } else {
            //Auth no longer in progress
            unsetInProgressState();
            wipeAuthData();

            if (!silent) {
              $rootScope.$emit(AUTH_EVENTS.LOGOUT);
            }

            $log.info('%cLogged :: OUT', 'color:#009966;font-weight:bold;');
          }
        };

        //Check if current user is allowed on passed-in stateAccessLevel
        this.authorize = function(stateAccessLevel) {
          return !!(RC_USER_ROLES[User.getRole()] & stateAccessLevel);
        };
      }
    );
})();
